// import { qs } from "./qs";

const _global = window;
const _navigator = _global.navigator;
let _ua = _navigator.userAgent;

function indexOf(str, eq) {
  const index = _ua.indexOf(str);

  return eq ? index === -1 : index > -1;
}

function match(re) {
  return _ua.match(re);
}

const versions = {
  trident: indexOf("Trident"), // IE内核
  presto: indexOf("Presto"), // opera内核
  webKit: indexOf("AppleWebKit"), // 苹果、谷歌内核
  gecko: indexOf("Gecko") && indexOf("KHTML", true), // 火狐内核
  mobile: !!match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
  // isApp: true,
  isOnline: indexOf("Online"),
  ios: !!match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || indexOf("iPhone"), // ios终端
  android: indexOf("Android") || indexOf("Adr"), // android终端
  iPhone: indexOf("iPhone"), // 是否为iPhone或者QQHD浏览器
  iPad: indexOf("iPad"), // 是否iPad
  webApp: indexOf("Safari", true), // 是否web应该程序，没有头部与底部
  weixin: indexOf("MicroMessenger"), // 是否微信 （2015-01-22新增）
  qq: /\sQQ/i.test(_ua), // 是否QQ
  wp8: indexOf("Windows Phone 8."),
};

// export const init = { versions, query: qs() };
// export function updateQs(url) {
//     return qs(url);
// }
// export { qs };
export default versions;
